<template>
    <div class="charts">
		<div class="charts__title charts-title">
			<div class="charts-title__elem">
				ОБЩИЙ ДОХОД И ДОХОД ИНВЕСТОРА В %
			</div>
			<div class="charts-title__elem charts-title__elem--right">
				<div class="chart__title-instr">
					<svg @click="switchModeGrid" style="width:24px;height:24px" viewBox="0 0 24 24">
						<path fill="#adc7e1" d="M19,11H13V5H19M19,19H13V13H19M11,11H5V5H11M11,19H5V13H11M3,21H21V3H3V21Z" />
					</svg>
					<div class="changeType-wrap" v-show="mode">
						<div :class="type==='percent' ? 'changeType-item changeType-item-active' : 'changeType-item'"  @click="setPercent">%</div>
						<div :class="type==='$' ? 'changeType-item changeType-item-active' : 'changeType-item'" @click="setDollars">$</div>
					</div>
					<div v-show="!mini" :class="mini ? 'compareMode compareMode-min' : 'compareMode'" @click="switchMode()">{{titleSwitchMode}}</div>
					<router-link :to="{name: 'chart' , query: { chart: 'strategy' }}" target="_blank">
						<i v-show="!fullStatus && !mini" class="icon-fullscreen"></i>
					</router-link>
				</div>
			</div>

		</div>
		<div class="charts__body chart">
			<div class="chart__info">
				<ProfitData  v-show="mode" @setYear="changeDate($event)" :type="type" :fullScreen="fullStatus" :mini="mini" @changeChart="setChart($event)">
				</ProfitData>
				<div class="chart__compare">
					<div v-show="!mode" class="compareData-legend">
						<div class="compareData-legend-item"
							 style="background:rgb(255, 173, 102)">2016</div>
						<div class="compareData-legend-item"
							 style="background:rgb(65, 230, 255)">2017</div>
						<div class="compareData-legend-item"
							 style="background:rgb(0, 255, 208)">2018</div>
						<div class="compareData-legend-item"
							 style="background:rgb(236, 255, 36)">2019</div>
					</div>
					<div class="mode-wrap">
						<div v-show="!mode" class="compareData">
							<div class="compareData-row">
								<div :class="typeProfit === 'pointProfit' || avverMode ?'compareData-row-item compareData-row-item-active' : 'compareData-row-item'" @click="switchProfitCommon()">Общий Доход</div>
								<div :class="typeProfit === 'pointInvest' || !avverMode ?'compareData-row-item compareData-row-item-active' : 'compareData-row-item'"  @click="switchProfitInvest()">Доход инвестора</div>
								<div class="compareData-row-item compareData-row-item-avver" @click="switchAvverLine()">Средний в месяц</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="echarts chart__item chart__item--h70" v-if="show">
				<IEcharts style=""
					  :option="bar"
					  :loading="loading"
					  :resizable="resize"
				/>
			</div>

			<div class="navWidget">
				<div v-for="(item,index) in navigateMenu" :key="index" :class="activeIndexNavigateMenu === index ? 'navWidget-item navWidget-itemActive' : 'navWidget-item'" @click="setActiveWidget(index)">
					{{item}}
				</div>
			</div>

			<div class="echarts chart__item chart__item--h30" v-if="activeIndexNavigateMenu === 1 && show">
				<ProfitTable />
			</div>

			<div class="echarts chart__item chart__item--h30" v-if="activeIndexNavigateMenu === 0 && show">
				<ProfitGistogramm />
			</div>

		</div>

    </div>
</template>
<script>
import { mapGetters } from "vuex";
import IEcharts from "vue-echarts-v3/src/full.js";
import ProfitData from './sig-summary-account-data-strategy';
import ProfitGistogramm from "./profit-gistagramm";
import ProfitTable from "../../../statistica/sig-year-profit"
export default {
    components : {
        ProfitData,
        IEcharts,
        ProfitGistogramm,
        ProfitTable
    },
    props: {
        update:{default:true},
        updateHight:{default:true},
        updateRight:{default:true},
        widthChart:{default:'93%'},
        fullStatus:{default:false},
        mini:{default:false}
    },
    data() {
        return {
            stat: [],
            show:true,
            symbol:'',
            loading:false,
            resize:true,
            type:'percent',
            typeProfit:'pointInvest',
            year:null,
            feutureProfit:0,
            avverMode:false,
            typeChart:null,
            navigateMenu:['ДОХОД В % ПО МЕСЯЦАМ','Таблица дохода'],
            activeIndexNavigateMenu:0,
            bar: {
                grid:{
                    height:"calc(100%-50px)",
                    width: "calc(100%-70px)",
                    top:'0',
                    left:'0',
                    bottom:'50px',
                    right:'70px'
                },
                tooltip: {
                    show: true,
                    trigger: "axis",
                    axisPointer: {
                    type: "cross",
                    axis: "auto"
                    }
                },
                xAxis: {
                    type: 'category',
                    //scale:true,
                    boundaryGap:false,
                    axisLine:{
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisTick: {
                        show: true,
                        alignWithLabel: true,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisPointer: {
                        show:true,
                        type: 'shadow',
                    },
                    axisLabel: {
                        align: 'left',
                        color: '#718da8',
                        //rotate:'-90'
                    },
                    splitLine: {
                        show:true,
                        interval:0,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    scale:false,
                    //interval:30,
                    max:150,
                    boundaryGap: true,
                    position:'right',
                    splitLine: {
                        show:false
                    },
                    scale:true,
                    axisLine: {
                        show:true,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisTick: {
                        inside: false,
                        lineStyle: {
                            color:'#374b62'
                        }
                    },
                    axisLabel: {
                        inside: false,
                        align: 'left',
                        verticalAlign:'middle',
                        margin:'8',
                        color:'#718da8',
                        formatter:'{value} %'
                    }
                },
                series: [
                {
                    name:'Средний доход в месяц',
                    data: [],
                    type: 'line',
                    zlevel:2,
                    smooth:true,
                        color: "#36e2ff",
                        showSymbol:false,
                        lineStyle: {
                            width: 1,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                    areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 1,
                                colorStops: [
                                {
                                    offset: 0,
                                    color: "rgba(139, 147, 33,0.2)" // color at 0% position
                                },
                                {
                                    offset: 1,
                                    color: "rgba(218, 236, 81, 0.1)" // color at 100% position
                                }
                                ],
                                globalCoord: false
                            }
                    },
                    markPoint: {
                        data:[
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#3d536b',
                                    fontFamily: 'Arimo'
                                },
                                value : 0,
                                xAxis: 0,
                                yAxis: 0
                            },
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#3d536b',
                                    fontFamily: 'Arimo'
                                },
                                    value : 0,
                                    xAxis: 0,
                                    yAxis: 0
                            }
                        ]
                    },
                    markLine: {
                        data:[
                                [
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                    },
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                        lineStyle: {
                                            color:'#00ffd0',
                                            type:'dotted',
                                            opacity:1
                                        },
                                        symbol:'none',
                                        label: {
                                            show:true
                                        }
                                    }
                                ],
                            ]
                        },
                },
                {
                    name:'Средний доход в месяц',
                    data: [],
                    type: 'line',
                    zlevel:2,
                    smooth:true,
                        color: "#00ffd0",
                        showSymbol:false,
                        lineStyle: {
                            width: 1,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                    areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 1,
                                colorStops: [
                                {
                                    offset: 0,
                                    color: "rgba(139, 147, 33,0.2)" // color at 0% position
                                },
                                {
                                    offset: 1,
                                    color: "rgba(218, 236, 81, 0.1)" // color at 100% position
                                }
                                ],
                                globalCoord: false
                            }
                    },
                    markPoint: {
                        data:[
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#3d536b',
                                    fontFamily: 'Arimo',
									// backgroundColor: '#3d536b',
									// borderColor: '#00ffd0',
									// borderWidth: '2px',
									// padding: [2, 14],
									// width: 57,
									// height: 20
                                },
                                value : 0,
                                xAxis: 0,
                                yAxis: 0
                            },
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
								symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#00ffd0',
                                    fontFamily: 'Arimo'
                                },
                                    value : 0,
                                    xAxis: 0,
                                    yAxis: 0
                            }
                        ]
                    },
                    markLine: {
                        data:[
                                [
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                    },
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                        lineStyle: {
                                            color:'#00ffd0',
                                            type:'dotted',
                                            opacity:1
                                        },
                                        symbol:'none',
                                        label: {
                                            show:true
                                        }
                                    }
                                ],
                            ]
                        },
                },
                {
                    name:'Совокупный доход',
                    data: [],
                    type: 'line',
                    zlevel:0,
                    smooth:true,
                        color: "#ff79e2",
                        showSymbol:false,
                        lineStyle: {
                            width: 1,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                    areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 1,
                                colorStops: [
                            {
                                offset: 0,
                                color: "rgba(0, 175, 255, 0.3)" // color at 0% position
                            },
                            {
                                offset: 1,
                                color: "rgba(0, 175, 255, 0.3)" // color at 100% position
                            }
                                ],
                                globalCoord: false
                            }
                    },
                    markPoint: {
                        data:[
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#3d536b',
                                    fontFamily: 'Arimo'
                                },
                                    value : 0,
                                    xAxis: 0,
                                    yAxis: 0
                            },
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#36e2ff',
                                    fontFamily: 'Arimo'
                                },
                                value : 0,
                                xAxis: 0,
                                yAxis: 0
                            },
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#36e2ff',
                                    fontFamily: 'Arimo'
                                },
                                    value : 0,
                                    xAxis: 0,
                                    yAxis: 0
                            },
                        ]
                    },
                    markLine: {
                        data:[
                                [
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                    },
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                        lineStyle: {
                                            color:'#36e2ff',
                                            type:'dotted',
                                            opacity:1
                                        },
                                        symbol:'none',
                                        label: {
                                            show:true
                                        }
                                    }
                                ],
                                [
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                    },
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                        lineStyle: {
                                            color:'#36e2ff',
                                            type:'dotted',
                                            opacity:1
                                        },
                                        symbol:'none',
                                        value:'ddbbe',
                                        label: {
                                            show:true,
                                            position:'middle',
                                        } ,
                                    }
                                ],
                            ]
                        },
                },
                {
                    name:'Чистый доход инвестора',
                    data: [],
                    type: 'line',
                    zlevel:2,
                    smooth:true,
                        color: "#ffad66",
                        showSymbol:false,
                        lineStyle: {
                            width: 1,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowBlur: 10,
                            shadowOffsetX: 10
                        },
                    areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 1,
                                colorStops: [
                                {
                                    offset: 0,
                                    color: "rgba(139, 147, 33,0.2)" // color at 0% position
                                },
                                {
                                    offset: 1,
                                    color: "rgba(218, 236, 81, 0.1)" // color at 100% position
                                }
                                ],
                                globalCoord: false
                            }
                    },
                    markPoint: {
                        data:[
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#3d536b',
                                    fontFamily: 'Arimo'
                                },
                                value : 0,
                                xAxis: 0,
                                yAxis: 0
                            },
                            {
                                silent: true,
								symbol: 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z',
                                symbolSize: [68, 19],
                                symbolRotate: '0',
                                symbolKeepAspect: false,
                                symbolOffset: ['50%', '0'],
                                label: {
                                    show:true,
                                    color:'#3d536b',
                                    fontFamily: 'Arimo'
                                },
                                    value : 0,
                                    xAxis: 0,
                                    yAxis: 0
                            }
                        ]
                    },
                    markLine: {
                        data:[
                                [
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                    },
                                    {
                                        xAxis:0,
                                        yAxis:0,
                                        lineStyle: {
                                            color:'#00ffd0',
                                            type:'dotted',
                                            opacity:1
                                        },
                                        symbol:'none',
                                        label: {
                                            show:true
                                        }
                                    }
                                ],
                            ]
                        },
                    },
                ]
            },
            commonPercent:null,
            mode:true
        }
    },
    computed : {
        ...mapGetters({
            getProfit:'accountstat/getMonthProfitStrategy',
            getStatistics: 'accountstat/getStatistics'
        }),
        titleSwitchMode() {
            if(this.mode)
                return 'Сравнить'
            else
                return 'Общий график'
        }
    },
    methods : {
        updateChart(signal) {
            if(signal === null)
                signal = 1;
            let stat = this.getProfit('');
            let dailyStat = this.getStatistics('');
            if (!stat || !dailyStat) {
                return;
            }
            this.feutureProfit = getFeutureProfit(dailyStat);
            this.mode ? getPoints(stat, this.bar, this.type, this.year, signal, this.typeChart, this.feutureProfit,this) : getComparePoints(stat, this.bar, this.typeProfit, this.avverMode);
        },
        setActiveWidget(index) {
            this.activeIndexNavigateMenu = index;
        },
        setChart(typeChart) {
            this.typeChart = typeChart;
            this.updateChart();
        },
        switchMode() {
            this.mode = !this.mode;
            this.updateChart();
        },
        switchModeGrid() {
            this.$emit('switchMode');
        },
        switchProfitCommon() {
            this.typeProfit = 'pointProfit';
            this.avverMode = true;
            this.updateChart();
        },
        switchProfitInvest() {
            this.typeProfit ='pointInvest'
            this.avverMode = false;
            this.updateChart();
        },
        switchAvverLine() {
            this.typeProfit ='pointLine'
            this.updateChart();
        },
        setPercent() {
            this.type = 'percent';
        },
        getCommonPercent(stat) {
            let dataProfit = [];
            for (let i = 0; i < stat.length; i++) {
                dataProfit.push(sumTo(i, stat, this.type))
            }
            this.commonPercent = dataProfit[dataProfit.length - 1];
        },
        setDollars() {
            this.type = '$';
        },
        changeDate(year) {
            if(year === 'Весь период') {
                this.year = null;
            } else {
                this.year = year;
            }
            this.updateChart();
        }
    },
    watch: {
        update: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateHight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        updateRight: function() {
            this.show = false
                this.$nextTick(() => {
                    this.show = true
                    this.$nextTick(() => {
                    })
                })
        },
        type: function() {
            this.updateChart();
        },
        commonPercent: function(newData, oldData) {
            let signal = newData > oldData ? 1 : newData < oldData ? -1 : 0;
            this.updateChart(signal);
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
                let stat = this.getProfit(this.symbol);
                this.stat = stat;
                this.getCommonPercent(this.stat);
                  //this.updateChart()
                  //this.loading = false;
        });
        this.updateChart()
    }
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-startegy-profit-line",
            handler: handler
        }
    });
}
function getProfitMonth(array) {
  let sum = 0;
    for (let i = 0; i < array.length; i++) {
        if(array[i].profit > 0)
            sum ++;
    }
    let profitMonth = 100/(array.length/sum);
  return profitMonth;
}
function getWorkDays(date) {
    let nowDay = new Date(date)
    let firstDate = new Date(nowDay.getFullYear(), nowDay.getMonth(), 1)
    let lastDate = new Date(nowDay.getFullYear(), nowDay.getMonth() + 1, 0)
    let numWorkDays = [];
    let currentDate = new Date(firstDate);
    while (currentDate <= lastDate) {
        // Skips Sunday and Saturday
        if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
            numWorkDays.push(currentDate.getDate());
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return numWorkDays;
}
function getFeutureProfit(stat) {
    let lastDay = stat.DailyRecords[stat.DailyRecords.length - 1]
    let days = getWorkDays(lastDay.Date)
    let firstDay = new Date(new Date(lastDay.Date).getFullYear(),new Date(lastDay.Date).getMonth(),days[0]);
    let firstDayMonthData = stat.DailyRecords.find((day)=> {
        return new Date(day.Date).getFullYear() === firstDay.getFullYear() && new Date(day.Date).getMonth() === firstDay.getMonth() && new Date(day.Date).getDate() === firstDay.getDate()
    })
    let featureEquity = firstDayMonthData.EquityClose + (firstDayMonthData.EquityClose - 1000000)*days.length/stat.DailyRecords.length
    let featureProfit = featureEquity - firstDayMonthData.EquityOpen;
    let profits = {
        featureProfit:featureProfit,
        featureProfitPercent:100/(firstDayMonthData.EquityClose/featureProfit),
        featureEquity:featureEquity
    }
    return profits;
}
function getProfitYears(array) {
    let sum = 0;
    for (let i = 0; i < array.length; i++) {
            sum +=array[i];
    }
    let profitMonth = sum/array.length;
  return profitMonth;
}
function UnicYear(stat) {
  let sum = {};
  for (let i = 0; i < stat.length; i++) {
        let str = stat[i].year
        sum[str] = true;
  }
  return Object.keys(sum);
}
function sumToYear(stat, year) {
    let sum = 0;
    for (let i = 0; i < stat.length; i++) {
        if(stat[i].year === parseInt(year))
            sum += stat[i].profit;
    }
    return sum;
}
function sumTo(n, array, type) {
  let sum = 0;
  if(type === 'percent') {
    for (var i = 0; i <= n; i++) {
        sum += array[i].profit;
    }
  } else {
     for (var i = 0; i <= n; i++) {
        sum += array[i].profitAbs;
    }
  }
  return sum;
}
function sumToInvest(n, array, type) {
    let sum = 0;
    let maxProfit = 0
    if(type === 'percent')
        maxProfit = array[0].profit;
    else
        maxProfit = array[0].profitAbs;
    if(type === 'percent') {
    for (let i = 0; i <= n; i++) {
        if(array[i].profit > maxProfit) {
            maxProfit = array[i].profit;
            sum += array[i].profit - array[i].profit * 0.363;
        }
        else if(array[i].profit > 0)
            sum += array[i].profit - array[i].profit * 0.03;
        else if(array[i].profit < 0)
            sum += array[i].profit + array[i].profit * 0.03;
    }
  } else {
    for (let i = 0; i <= n; i++) {
        if(array[i].profitAbs > maxProfit) {
            maxProfit = array[i].profitAbs;
            sum += array[i].profitAbs - array[i].profitAbs * 0.363;
        }
        else  if(array[i].profit > 0)
            sum += array[i].profitAbs - array[i].profitAbs * 0.03;
        else if (array[i].profitAbs < 0)
            sum += array[i].profitAbs + array[i].profitAbs * 0.03;
    }
  }
  return sum;
}
function nullChart(chartObject) {
    for (let i = 0; i < chartObject.series.length; i++) {
        chartObject.series[i].data = 0;
        chartObject.series[i].markPoint.data[0].xAxis = null;
        chartObject.series[i].markPoint.data[0].yAxis = null;
        chartObject.series[i].markPoint.data[1].xAxis = null;
        chartObject.series[i].markPoint.data[0].yAxis = null;
        chartObject.series[i].markLine.data[0][0].yAxis = null;
        chartObject.series[i].markLine.data[0][1].yAxis = null;
    }
}
function getMaxPoint(point, type) {
    let maxArrPoint = [];
    let minArrPoint = [];
    if(type === undefined)
        return
    for (let i =0; i < point.length; i++) {
        maxArrPoint.push(Math.max(...point[i][type]));
        minArrPoint.push(Math.min(...point[i][type]));
    }
    let minMax = {max:Math.max(...maxArrPoint),
                    min:Math.min(...minArrPoint)}
    return minMax;
}
function getComparePoints(stats, chartObject, type, avverMode) {
    nullChart(chartObject)
    let allYears = UnicYear(stats);
    let point = []
    for(let i = 0; i < allYears.length; i++){
        point.push(getYearPoint(stats, allYears[i], 'percent', type, avverMode))
    }
    chartObject.xAxis.data = point[2].pointsX;

    chartObject.yAxis.max = getMaxPoint(point, type).max + getMaxPoint(point, type).max*0.15;
    chartObject.yAxis.min = getMaxPoint(point, type).min - getMaxPoint(point, type).min*0.15;
    let colors = ['rgb(255, 173, 102)', 'rgb(65, 230, 255)', 'rgb(0, 255, 208','rgb(236, 255, 36)','rgb(167, 174, 255)'];
    let symbols = ['path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z', 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z', 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z','path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z', 'path://M4,6.66133815e-16 C4.69333333,6.66133815e-16 22.36,7.40148683e-17 57,-1.11022302e-15 L57,20 L4,20 L5.55111512e-17,10 C0.666666667,8.33333333 2,5 4,6.66133815e-16 Z M5,2 L2,10 L5,18 L55,18 L55,2 L5,2 Z']
     //chartObject.series[0].data = point.pointsY
    for (let i = 0; i < chartObject.series.length; i++) {
        chartObject.series[i].data = point[i][type];
        chartObject.series[i].color = colors[i];
        chartObject.series[i].markPoint.data[0].xAxis = (point[i].pointsX[point[i].pointsX.length - 1]) - 1;
        chartObject.series[i].markPoint.data[0].yAxis = point[i][type][point[i][type].length - 1];
        chartObject.series[i].markPoint.data[0].value = point[i][type][point[i][type].length - 1];
        chartObject.series[i].markPoint.data[0].label.color = colors[i];
        chartObject.series[i].markPoint.data[0].symbol = symbols[i];
        //chartObject.series[i].markLine.data[0][0].yAxis = point[i].pointInvest[point[i].pointInvest.length - 1];
        //chartObject.series[i].markLine.data[0][1].yAxis = point[i].pointInvest[point[i].pointInvest.length - 1];
        //chartObject.series[i].markLine.data[0][0].xAxis = 3
        //chartObject.series[i].markLine.data[0][1].xAxis = 11
    }
}
function getYearPoint (stats, year, type, typeProfit,avverMode) {
    let yearArr = [];
    let point = {
        pointsX:[],
        pointLine:[],
        pointProfit:[],
        pointInvest:[]
    }
    for (let i = 0; i < stats.length; i++) {
        if(stats[i].year === parseInt(year))
            yearArr.push(stats[i])
    }
    let sison = yearArr.length < 11 && yearArr[0].month !== 0;
    for(let i = 0; i < yearArr.length; i++) {
        let month = ('0' + (yearArr[i].month + 1)).slice(-2);
        point.pointsX.push(yearArr[i].month + 1);
        if(!avverMode)
            point.pointLine.push(type === 'percent' ? (sumToInvest(i, yearArr, type) / (i + 1)).toFixed(2) : (sumToInvest(i,yearArr, type) / (i + 1)).toFixed());
        else
            point.pointLine.push(type === 'percent' ? (sumTo(i, yearArr, type) / (i + 1)).toFixed(2) : (sumTo(i,yearArr, type) / (i + 1)).toFixed());
        point.pointProfit.push(type === 'percent' ? ((sumTo(i,yearArr, type))).toFixed(2) : sumTo(i,yearArr, type));
        point.pointInvest.push(type === 'percent' ? (sumToInvest(i, yearArr, type)).toFixed(2) : (sumToInvest(i, yearArr, type)).toFixed());
    }
    if(sison) {
        for(let i = 0; i < yearArr[0].month; i++) {
            point[typeProfit].unshift(0);
        }
    }
    return point;
}
function getPoints(stats, chartObject, type, year, signal, typeProfitChart, featureProfit,context) {
    nullChart(chartObject);
    let month = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь']
    let years = UnicYear(stats);
    let point = {
         pointsX: [],
         pointsY: [],
         pointLine:[],
         pointProfit:[],
         pointInvest:[],
         pointYearProfit:[],
         pointPositiveMonth:[]
    }
    signal < 0 ? chartObject.series[1].color = "#ff9292" : chartObject.series[1].color = "#00ffd0";
    signal < 0 ? chartObject.series[2].color = "#ff9292" : chartObject.series[2].color = "#36e2ff";
    signal < 0 ? chartObject.series[3].color = "#ff9292" : chartObject.series[3].color = "#00ffd0";
    let typeProfit = null;
    let yearArr = [];
    if(type === 'percent')
        typeProfit = stats[0].profit;
    else
        typeProfit = stats[0].profitAbs;
    if(year !== null) {
        for (let i = 0; i < stats.length; i++) {
            if(stats[i].year === parseInt(year))
                yearArr.push(stats[i])
        }
        for(let i = 0; i < yearArr.length; i++) {
            let month = ('0' + (yearArr[i].month + 1)).slice(-2);
            point.pointsX.push(`${month}.${yearArr[i].year}`);
            point.pointLine.push(type === 'percent' ? (sumTo(i, yearArr, type) / (i + 1)).toFixed(2) : (sumTo(i,yearArr, type) / (i + 1)).toFixed());
            point.pointProfit.push(type === 'percent' ? ((sumTo(i,yearArr, type))).toFixed(2) : sumTo(i,yearArr, type));
            point.pointInvest.push(type === 'percent' ? (sumToInvest(i, yearArr, type)).toFixed(2) : (sumToInvest(i, yearArr, type)).toFixed());
        }
    } else {
        for (let i = 0; i < stats.length; i++) {
            let month = ('0' + (stats[i].month + 1)).slice(-2)
                point.pointsX.push(`${month}.${stats[i].year}`)
                point.pointLine.push(type === 'percent' ? (sumTo(i,stats, type) / (i + 1)).toFixed(2) : (sumTo(i,stats, type) / (i + 1)).toFixed());
                point.pointProfit.push(type === 'percent' ? ((sumTo(i,stats, type))).toFixed(2) : sumTo(i,stats, type));
                point.pointInvest.push(type === 'percent' ? (sumToInvest(i, stats, type)).toFixed(2) : (sumToInvest(i, stats, type)).toFixed());
        }
    }
    //Positive Month
    let monthesStat = []
    for(let i = 0;i < stats.length; i++)
        monthesStat.push((getProfitMonth(stats.slice(i)).toFixed(2)));
    point.pointPositiveMonth = monthesStat.reverse();
    //Avverage Year Profit Point
    let yearsStat = [];
    for(let i = 0; i < years.length; i++)
        yearsStat.push(sumToYear(stats,years[i]));
    let averYersStat = []
    for(let i = 0; i < years.length; i++)
        averYersStat.push((getProfitYears(yearsStat.slice(i)).toFixed(2)));
    point.pointYearProfit = averYersStat.reverse();
    if(!typeProfitChart) {
        point.pointProfit.unshift(0);
        point.pointInvest.unshift(0);
        point.pointLine.unshift(0);
    } else {
        point[typeProfitChart].unshift(0);
    }
    point.pointsX.unshift('');
    years.unshift('');
    if(typeProfitChart === 'pointYearProfit')
        chartObject.xAxis.data = years;
    else
        chartObject.xAxis.data = point.pointsX;
    if(!typeProfitChart) {
        chartObject.series[1].data = point.pointLine
        chartObject.series[2].data = point.pointProfit
        chartObject.series[3].data = point.pointInvest
    } else {
        chartObject.series[1].data = point[typeProfitChart];
        chartObject.series[1].name = '';
    }
     chartObject.yAxis.max = (Math.max(...typeProfitChart ? point[typeProfitChart] : point.pointProfit) + (Math.max(...typeProfitChart ? point[typeProfitChart] : point.pointProfit)*0.25)).toFixed();
     chartObject.yAxis.min = Math.min(...typeProfitChart ? point[typeProfitChart] : point.pointProfit);

     if(!typeProfitChart) {
        //MarkPoint for MaxPoint ProfitLine
        chartObject.series[2].markPoint.data[1].yAxis = 'max';
        chartObject.series[2].markPoint.data[1].xAxis = point.pointsX[point.pointsX.length - 1];
        chartObject.series[2].markPoint.data[1].value = Math.max(...point.pointProfit);

        //MarkPoint for MaxPoint AvverageProfit
        chartObject.series[1].markPoint.data[0].yAxis = 'max';
        chartObject.series[1].markPoint.data[0].xAxis = point.pointsX[point.pointsX.length - 1];
        chartObject.series[1].markPoint.data[0].value = Math.max(...point.pointLine);

        //MarkPoint for MaxPoint ProfitInvestor
        chartObject.series[3].markPoint.data[0].yAxis = 'max';
        chartObject.series[3].markPoint.data[0].xAxis = point.pointsX[point.pointsX.length - 1];
        chartObject.series[3].markPoint.data[0].value = Math.max(...point.pointInvest);
     } else {
        chartObject.series[1].markPoint.data[0].yAxis = 'max';
        chartObject.series[1].markPoint.data[0].xAxis = typeProfitChart === 'pointYearProfit' ? years[years.length - 1] : point.pointsX[point.pointsX.length - 1];
        chartObject.series[1].markPoint.data[0].value = Math.max(...point[typeProfitChart]);
     }

     if(!typeProfitChart) {
     //MarkPoint for CurrencyPoint AvverageProfit
        chartObject.series[1].markPoint.data[1].label.color="#3d536b";
        chartObject.series[1].markPoint.data[1].symbol = 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z';
        chartObject.series[1].markPoint.data[1].yAxis = point.pointLine[point.pointLine.length - 1];
        chartObject.series[1].markPoint.data[1].xAxis = point.pointsX[point.pointsX.length - 1];
        chartObject.series[1].markPoint.data[1].value = point.pointLine[point.pointLine.length - 1];

        //MarkPoint for CurrencyPoint ProfitLine
       chartObject.series[2].markPoint.data[2].label.color="#3d536b"
        chartObject.series[2].markPoint.data[2].symbol = 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z';
        chartObject.series[2].markPoint.data[2].yAxis = point.pointProfit[point.pointProfit.length - 1];
        chartObject.series[2].markPoint.data[2].xAxis = point.pointsX[point.pointsX.length - 1];
        chartObject.series[2].markPoint.data[2].value = point.pointProfit[point.pointProfit.length - 1];

        //MarkPoint for CurrencyPoint ProfitInvestor
        chartObject.series[3].markPoint.data[1].label.color="#3d536b";
        chartObject.series[3].markPoint.data[1].symbol = 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z';
		chartObject.series[3].markPoint.data[1].yAxis = point.pointInvest[point.pointInvest.length - 1];
        chartObject.series[3].markPoint.data[1].xAxis = point.pointsX[point.pointsX.length - 1];
        chartObject.series[3].markPoint.data[1].value = point.pointInvest[point.pointInvest.length - 1];
     }
     else {
        chartObject.series[1].markPoint.data[1].label.color="#3d536b";
        chartObject.series[1].markPoint.data[1].symbol = 'path://M4.90347 1H55V10V19H4.85821C4.82531 18.932 4.78969 18.8581 4.75151 18.7785C4.51115 18.2773 4.16957 17.5507 3.76687 16.6531C2.99774 14.9389 2.00828 12.607 1.07551 10.0352C2.01472 7.87683 3.00624 5.53483 3.77656 3.69951C4.18369 2.72951 4.52935 1.9003 4.77325 1.31351C4.82059 1.19963 4.86409 1.09488 4.90347 1Z';
        chartObject.series[1].markPoint.data[1].yAxis = point[typeProfitChart][point[typeProfitChart].length - 1];
        chartObject.series[1].markPoint.data[1].xAxis = typeProfitChart === 'pointYearProfit' ? years[years.length - 1] : point.pointsX[point.pointsX.length - 1];
        chartObject.series[1].markPoint.data[1].value = point[typeProfitChart][point[typeProfitChart].length - 1];
     }

     if(!typeProfitChart) {
        //MarkLine for MaxPoint ProfitLine
        chartObject.series[2].markLine.data[0][0].yAxis = 'max';
        chartObject.series[2].markLine.data[0][0].xAxis = type === 'percent' ?  point.pointProfit.indexOf((Math.max(...point.pointProfit).toString())) : point.pointProfit.indexOf(Math.max(...point.pointProfit));
        chartObject.series[2].markLine.data[0][1].yAxis = 'max';
        chartObject.series[2].markLine.data[0][1].xAxis = point.pointsX[point.pointsX.length - 1];

        //MarkLine for MaxPoint AverrLine
        chartObject.series[1].markLine.data[0][0].yAxis = 'max';
        chartObject.series[1].markLine.data[0][0].xAxis = point.pointLine.indexOf((Math.max(...point.pointLine).toString()));
        chartObject.series[1].markLine.data[0][1].yAxis = 'max';
        chartObject.series[1].markLine.data[0][1].xAxis = point.pointsX[point.pointsX.length - 1];

        //MarkLine for MaxPoint ProfitInvestor
        let profitInvestInt = [];
        for(let i = 0; i < point.pointInvest.length; i++)
            profitInvestInt.push(parseFloat(point.pointInvest[i]));
        chartObject.series[3].markLine.data[0][0].yAxis = 'max';
        chartObject.series[3].markLine.data[0][0].xAxis = profitInvestInt.indexOf((Math.max(...profitInvestInt)));
        chartObject.series[3].markLine.data[0][1].yAxis = 'max';
        chartObject.series[3].markLine.data[0][1].xAxis = point.pointsX[point.pointsX.length - 1];
    } else {
        chartObject.series[1].markLine.data[0][0].yAxis = 'max';
        chartObject.series[1].markLine.data[0][0].xAxis = point[typeProfitChart].indexOf((Math.max(...point[typeProfitChart]).toFixed(2)));
        chartObject.series[1].markLine.data[0][1].yAxis = 'max';
        chartObject.series[1].markLine.data[0][1].xAxis = typeProfitChart === 'pointYearProfit' ? years[years.length - 1] : point.pointsX[point.pointsX.length - 1];;
    }
    //Prognosis MarkPoint
    chartObject.series[2].markPoint.data[0].yAxis = parseFloat(point.pointProfit[point.pointProfit.length - 2]) + featureProfit.featureProfitPercent;
    chartObject.series[2].markPoint.data[0].xAxis = point.pointsX[point.pointsX.length - 1];
    chartObject.series[2].markPoint.data[0].value = (parseFloat(point.pointProfit[point.pointProfit.length - 2]) + featureProfit.featureProfitPercent).toFixed(2);
    //Prognosis MarkLine and Label
    chartObject.series[2].markLine.data[1][0].yAxis = parseFloat(point.pointProfit[point.pointProfit.length - 2]) + featureProfit.featureProfitPercent;
    chartObject.series[2].markLine.data[1][0].xAxis = point.pointsX[point.pointsX.length - 1];
    chartObject.series[2].markLine.data[1][1].yAxis = parseFloat(point.pointProfit[point.pointProfit.length - 2]) + featureProfit.featureProfitPercent;
    chartObject.series[2].markLine.data[1][1].xAxis = point.pointsX[0];
    chartObject.series[2].markLine.data[1][1].value = 'Прогноз на ' +  month[stats[stats.length - 1].month] + ' ' +  stats[stats.length - 1].year + 'г.' + '  '+'+' + '%' + featureProfit.featureProfitPercent.toFixed(2)  + '  ' + '+' + '$' + context.$moneyf(featureProfit.featureProfit) + '  '+'Вероятность 96%' + '  ' + 'Факт.' + ' ' + '%' + (stats[stats.length - 1].profit).toFixed(2);
}
</script>
<style lang="less" scoped>
.echarts {
    min-width: 100%;
    background: #3d536b;
}
.navWidget {
    display: flex;
    min-height: 40px;
    align-items: center;
    &-item {
        font-family: Arimo;
        font-size: 11px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 0.4px;
        color: #adc4e1;
        text-transform: uppercase;
        padding: 14px 12px 0 12px;
        box-sizing: border-box;
        cursor: pointer;
        height: 100%;
    }
    &-itemActive {
        background: #374b62;
        color:#fff;
    }
}
.mode-wrap {
    display: flex;
    height: 40px;
    justify-content: flex-end;
    flex-grow: 1;
    a {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            font-size: 20px;
            margin-left: 0px;
            color:#adc4e1;
        }
    }
}


.chart-wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}
.chart-main-wrap {

    &_down {
        flex-basis:40%;
    }
}

.chart__title {

    &-instr {
        display: flex;
        align-items:center;
        a {
            margin: auto;
            color:#adc4e1;
        }
        i {
            margin: 0px 20px 0px 20px;
            font-size: 23px;
        }
        svg {
            margin-right:8px;
            cursor:pointer;
        }
    }
}

.chart__inf-wrap {
    padding: 0px 12px 12px 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    padding-right: 16px;
    position: absolute;
    z-index: 1;
    box-sizing: border-box;
    i {
        margin-left: 20px;
        font-size: 23px;
    }
}

.echarts-full {
    height: calc(100vh - 225px);
}
.changeType {
    &-wrap {
        display: flex;
        align-items: start;
        //margin-right: 30%;
    }
    &-item {
        color: #adc4e1;
        cursor: pointer;
        font-family: Arimo;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        width:40px;
        height: 40px;
        text-align: center;
        &-active {
            background: #00ffd0;
            color: #374b62;
        }
    }
}
.compareData {
    margin-left:18px;
    &-legend {
       padding-top: 80px;
        &-item {
            margin-bottom:6px;
            border-radius: 4px;
            border: 1px solid #374b62;
            padding: 4px;
            margin-left: 8px;
            box-sizing: border-box;
            text-align: center;
            color: #374b62;
            font-size: 13px;
            font-family: Arimo;
            text-transform: uppercase;
            width:48px;
        }
    }
    &-row {
        display:flex;
        &-item {
            padding: 0px 12px 0 12px;
            box-sizing: border-box;
            text-align: center;
            color: #adc4e1;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Arimo;
            cursor:pointer;
            text-transform: uppercase;
            height: 40px;
            &-active {
                border: 1px solid #00ffd0;
                background: #00ffd0;
                color: #374b62;
            }
            &-avver {
                border: 1px solid #00ffd0;
                color:#00ffd0;
            }
        }
    }
}
.compareMode {
    background: rgb(65, 230, 255);
    padding: 4px 12px 4px 12px;
    color: #374b62;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    font-family: Arimo;
    display: flex;
    align-items: center;
    cursor:pointer;
    text-transform: uppercase;
    height:40px;
    &-min {
        font-size: 14px;
        padding: 4px 8px 4px 8px;
    }
}
@media screen and (min-width: 2240px) {
      .echarts  {
     // height: 828px;
      }
  }
</style>

